import { renderToStaticMarkup } from 'react-dom/server';
import { SupportingMaterialMarkdown } from './SupportingMaterialMarkdown';
import { injectReadyRasterFiguresIntoMarkdown } from './supportingMaterialContentSegments';
import type { StepRasterFigureDto } from './types';

const printMarkdownStyles = `
  .markdown-body { font-size: 14px; line-height: 1.6; color: #333; }
  .markdown-body p { margin: 0 0 0.75em; }
  .markdown-body ul, .markdown-body ol { margin: 0 0 0.75em 1.25em; padding: 0; }
  .markdown-body table { border-collapse: collapse; width: 100%; margin: 0.75em 0; page-break-inside: avoid; }
  .markdown-body th, .markdown-body td { border: 1px solid #ccc; padding: 8px; text-align: left; vertical-align: top; }
  .markdown-body th { background: #f3f4f6; font-weight: 600; }
  .markdown-body hr { border: none; border-top: 1px solid #e5e7eb; margin: 1em 0; }
  .markdown-body svg,
  .markdown-body img { max-width: 100%; height: auto; display: block; margin: 0.75em auto; page-break-inside: avoid; }
  .ai-generated-figure { position: relative; display: inline-block; max-width: 100%; page-break-inside: avoid; }
  .ai-generated-figure img,
  .ai-generated-figure svg { margin: 0.75em auto; }
  /* Print has no Tailwind — hide the live badge and draw a CSS label instead. */
  .ai-generated-figure > span { display: none !important; }
  .ai-generated-figure::after {
    content: "AI-generated";
    position: absolute;
    right: 6px;
    bottom: 6px;
    z-index: 1;
    padding: 2px 6px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0.02em;
    pointer-events: none;
  }
  /* Headings render as <p> with Tailwind classes; print window has no Tailwind. */
  .markdown-body .font-semibold {
    font-weight: 700;
    color: #111827;
  }
  .material-card--worksheet .markdown-body .font-semibold {
    font-size: 1.05em;
    margin-top: 1.1em;
    margin-bottom: 0.35em;
  }
`;

export function renderSupportingMaterialMarkdownToHtml(
  content: string,
  figures?: StepRasterFigureDto[]
): string {
  if (!content?.trim()) return '';

  const injected = figures?.length
    ? injectReadyRasterFiguresIntoMarkdown(content, figures)
    : content;

  const body = renderToStaticMarkup(
    <div className="markdown-body">
      <SupportingMaterialMarkdown content={injected} rasterImages="plain" variant="print" />
    </div>
  );

  return `<style>${printMarkdownStyles}</style>${body}`;
}

export function getSupportingMaterialPrintStyles(): string {
  return printMarkdownStyles;
}
